import React from 'react';
import { Button, Alert } from '@/components/ui';
import ResponsiveModal from './ResponsiveModal';

interface CancelTaskConfirmationModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  taskName?: string;
}

const CancelTaskConfirmationModal: React.FC<CancelTaskConfirmationModalProps> = ({
  visible,
  onClose,
  onConfirm,
  taskName
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <ResponsiveModal
      isOpen={visible}
      onClose={onClose}
      title="Cancel Task"
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onClose}>
            No
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={handleConfirm}
          >
            Yes
          </Button>
        </>
      }
    >
      <Alert variant="warning">
        <i className="bi bi-exclamation-triangle tw-mr-2"></i>
        This operation cannot be undone. Are you sure?
      </Alert>
      {taskName && (
        <p className="tw-mb-0">
          <strong>Task:</strong> {taskName}
        </p>
      )}
    </ResponsiveModal>
  );
};

export default CancelTaskConfirmationModal;
